import React,{useRef} from "react";
import styles from "./css/ProductDetail.module.css";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { BsCaretDownFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { Image,Button } from "react-bootstrap";
import Slider from "react-slick";
import { GoPlus } from "react-icons/go";
import { GrSubtract } from "react-icons/gr";
import { FaCartPlus } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { Player } from "video-react";


import { FiChevronLeft,FiChevronRight  } from "react-icons/fi";
const courses = [
  { title: "React Basics", image: "https://via.placeholder.com/200x300" },
  { title: "Advanced Node.js", image: "https://via.placeholder.com/200x300" },
  { title: "Fullstack Mastery", image: "https://via.placeholder.com/200x300" },
  { title: "Design Thinking", image: "https://via.placeholder.com/200x300" },
];

export default function ProductDetails() {
  const settings = {
    dots: true,
    infinite: true,
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    arrows: true,
  };

  const navigate = useNavigate();

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };


  return (
    <div className={styles.detailcontainer}>
      <div className={styles.detailBox}>
        <div className={styles.datailLink}>
          <ul>
            <li>
              {" "}
              <Link style={{ textDecoration: "none" }}>Services</Link>{" "}
              <MdOutlineArrowForwardIos
                style={{ marginTop: 6, marginLeft: 5 }}
              />{" "}
            </li>
            <li>
              {" "}
              <Link style={{ textDecoration: "none" }}>
                Beauty Service
              </Link>{" "}
              <MdOutlineArrowForwardIos
                style={{ marginTop: 6, marginLeft: 5 }}
              />
            </li>
            <li>
              {" "}
              <Link style={{ textDecoration: "none" }}>Wax & Glow</Link>
            </li>
          </ul>
        </div>

        <div className={styles.detailRow}>
          <div className={styles.detailContain}>
            <h2 className={styles.deatailHeader}>Full Body Waxing</h2>
            <div style={{ display: "flex" }}>
              <BsCaretDownFill
                size={20}
                style={{ marginTop: 3 }}
                color="#156508"
              />{" "}
              <span style={{ marginLeft: 10, color: "#2062AF" }}>Package </span>
              <div
                style={{
                  display: "flex",
                  color: "#2062AF",
                  marginLeft: 10,
                  marginTop: 3,
                }}
              >
                <FaStar
                  size={19}
                  style={{ marginRight: 10, color: "#F79219" }}
                />
                4.83 (4.4 M bookings)
              </div>
            </div>
            <div className={styles.imageContainer}>
              <div className={styles.singleImg}>
                <Image
                  src="https://images.ctfassets.net/hjcv6wdwxsdz/5cODDwoG5rBwrazOzL8jP0/fa75978750363b63fb1036d383d20490/black-man-smiling-getting-back-massage.jpg"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className={styles.multipleImg}>
                <Image
                  src="https://images.ctfassets.net/hjcv6wdwxsdz/5cODDwoG5rBwrazOzL8jP0/fa75978750363b63fb1036d383d20490/black-man-smiling-getting-back-massage.jpg"
                  className={styles.MultipleSingleimg}
                />
                <Image
                  src="https://images.ctfassets.net/hjcv6wdwxsdz/5cODDwoG5rBwrazOzL8jP0/fa75978750363b63fb1036d383d20490/black-man-smiling-getting-back-massage.jpg"
                  className={styles.MultipleSingleimg}
                />
                <Image
                  src="https://images.ctfassets.net/hjcv6wdwxsdz/5cODDwoG5rBwrazOzL8jP0/fa75978750363b63fb1036d383d20490/black-man-smiling-getting-back-massage.jpg"
                  className={styles.MultipleSingleimg}
                />

                <Image
                  src="https://images.ctfassets.net/hjcv6wdwxsdz/5cODDwoG5rBwrazOzL8jP0/fa75978750363b63fb1036d383d20490/black-man-smiling-getting-back-massage.jpg"
                  className={styles.MultipleSingleimg}
                />

                <Image
                  src="https://images.ctfassets.net/hjcv6wdwxsdz/5cODDwoG5rBwrazOzL8jP0/fa75978750363b63fb1036d383d20490/black-man-smiling-getting-back-massage.jpg"
                  className={styles.MultipleSingleimg}
                />
              </div>
            </div>

            <div className={styles.detailPrice}>
              <div className={styles.detailPriceItem}>
                <div>
                  <span
                    style={{
                      marginTop: 10,
                      fontFamily: "Inter, sans-serif",
                      color: "red",
                    }}
                  >
                    -65%
                  </span>
                  <span
                    style={{
                      fontSize: 25,
                      marginLeft: 10,
                      fontWeight: "700",
                      fontFamily: "Inter, sans-serif",
                      color: "#2062AF",
                    }}
                  >
                    ₹1,629{" "}
                  </span>
                </div>
                <div>
                  <span
                    style={{
                      color: "#466590",
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    M.R.P:{" "}
                  </span>
                  <span
                    style={{
                      color: "#466590",
                      fontFamily: "Inter, sans-serif",
                      textDecoration: "",
                    }}
                  >
                    ₹1,629
                  </span>
                </div>
              </div>

              <div className={styles.detailBtnBox}>
                <button className={styles.addtocartBtn}>Add to Cart</button>
                <button className={styles.bookNowBtn}>Book Now</button>
              </div>
            </div>

            <ul style={{ fontFamily: "Inter, sans-serif" }}>
              <li>Waxing: Full Body </li>
              <li>Facial: Crave Beauty banana Hydrating facial</li>
              <li>Threading: Eye Brow Threading, Upper Leave Threading</li>
            </ul>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum
            </p>
          </div>
          <div className={styles.detailcart}>
            <div className={styles.cartlist}>
              <h4 style={{ marginTop: 10, marginLeft: 10, color: "#002E6E" }}>
                Cart
              </h4>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>Complete chocalate waring</p>
                <div
                  style={{
                    display: "flex",
                    width: 70,
                    height: 30,
                    borderRadius: 10,
                    border: "2px solid #07448E",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <GoPlus style={{ marginLeft: 5, color: "#07448E" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      color: "#07448E",
                    }}
                  >
                    1
                  </span>
                  <GrSubtract
                    style={{
                      marginRight: 5,
                      fontFamily: "Inter, sans-serif",
                      color: "#07448E",
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "#002E6E",
                    fontFamily: "Inter, sans-serif",
                    fontSize: 19,
                  }}
                >
                  ₹1000
                </span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>Complete chocalate waring</p>
                <div
                  style={{
                    display: "flex",
                    width: 70,
                    height: 30,
                    borderRadius: 10,
                    border: "2px solid #07448E",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <GoPlus style={{ marginLeft: 5, color: "#07448E" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      color: "#07448E",
                    }}
                  >
                    1
                  </span>
                  <GrSubtract
                    style={{
                      marginRight: 5,
                      fontFamily: "Inter, sans-serif",
                      color: "#07448E",
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "#002E6E",
                    fontFamily: "Inter, sans-serif",
                    fontSize: 19,
                  }}
                >
                  ₹1000
                </span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>Complete chocalate waring</p>
                <div
                  style={{
                    display: "flex",
                    width: 70,
                    height: 30,
                    borderRadius: 10,
                    border: "2px solid #07448E",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <GoPlus style={{ marginLeft: 5, color: "#07448E" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      color: "#07448E",
                    }}
                  >
                    1
                  </span>
                  <GrSubtract
                    style={{
                      marginRight: 5,
                      fontFamily: "Inter, sans-serif",
                      color: "#07448E",
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "#002E6E",
                    fontFamily: "Inter, sans-serif",
                    fontSize: 19,
                  }}
                >
                  ₹1000
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  background: "#002E6E",
                  padding: 8,
                  borderRadius: 10,
                  color: "#fff",
                  alignItems: "center",
                  fontSize: 12,
                }}
                onClick={() => navigate("/cartHome")}
              >
                View Cart
                <span
                  style={{
                    color: "#fff",
                    fontFamily: "Inter, sans-serif",
                    fontSize: 14,
                  }}
                >
                  ₹1000
                </span>
              </div>
            </div>

            <div className={styles.videoViewDetail}>
              <h5 style={{ color: "#002E6E" }}>Service Explain</h5>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                   height:"250px"
                }}
              >
                <Player
                  autoPlay
                  muted
                  playsInline
                  fluid={false}
                  width="100%"
                  height="100%"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                >
                  <source src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4" />
                </Player>
              </div>
            </div>

          <div className={styles.relativecartDetail}>
      <h5 style={{ color: "#002E6E" }}>Related Services</h5>

      {/* Arrows */}
      <div style={{ position: "relative" }}>
        <Button    
        style={{
            position: "absolute",
            left: -10,
            top: "40%",
            zIndex: 10,
            cursor: "pointer",
            borderRadius:100,
            background:"rgba(0,0,0,0.5)",
            border:"none"
          }}  onClick={() => scroll("left")} size="sm">
  <FiChevronLeft
          size={20}
        
         
        />
        </Button>
        <Button
         style={{
            position: "absolute",
            right: -10,
            top: "40%",
            zIndex: 10,
            cursor: "pointer",
             borderRadius:100,
            background:"rgba(0,0,0,0.5)",
            border:"none"
          }}
          onClick={() => scroll("right")}
          size="sm"
        >
      
        <FiChevronRight
          size={20}
         
          
        />
</Button>
        {/* Scrollable Cards */}
        <div
          className={styles.raltivecartRow}
          ref={scrollRef}
          style={{
            display: "flex",
            overflowX: "auto",
            scrollBehavior: "smooth",
            gap: "15px",
            paddingBottom: "10px",
          }}
        >
          {[...Array(4)].map((_, i) => (
            <div className={styles.relativeCard} key={i}>
              <div className={styles.relativecardImage}>
                <img
                  src="https://www.nerdwallet.com/tachyon/2021/11/GettyImages-1337284161.jpg?resize=2400%2C1440"
                  alt="Service"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />
              </div>
              <h6 style={{ marginTop: 10, fontSize: 13, color: "#002E6E" }}>
                Full Body Waxing
              </h6>
              <div style={{ display: "flex" }}>
                <BsCaretDownFill size={18} color="#156508" />
                <span style={{ color: "#2062AF", fontSize: 12, marginLeft: 2 }}>
                  Package
                </span>
                <div style={{ display: "flex", marginLeft: 10 }}>
                  <FaStar size={12} color="#F79219" />
                  <span style={{ fontSize: 12 }}>4.83</span>
                </div>
              </div>
              <div>
                <span style={{ color: "red", fontSize: 12 }}>-65%</span>
                <span
                  style={{
                    fontSize: 20,
                    marginLeft: 10,
                    fontWeight: "700",
                    color: "#2062AF",
                  }}
                >
                  ₹1,629
                </span>
              </div>
              <div>
                <span style={{ color: "#466590", fontSize: 12 }}>M.R.P: </span>
                <span
                  style={{
                    color: "#466590",
                    fontSize: 12,
                    textDecoration: "line-through",
                  }}
                >
                  ₹1,629
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

            <div
              style={{
                width: "100%",
                border: "2px solid #66D6FF",
                marginTop: 10,
                height: 170,
                borderRadius: 10,
                padding: 10,
              }}
            >
              <h5 style={{ color: "#002E6E" }}>HC Promise</h5>

              <p style={{ color: "#2062AF" }}>
                <FaCheck color="#F79219" /> 4.5+ Rated Beauticians
              </p>
              <p style={{ color: "#2062AF" }}>
                <FaCheck color="#F79219" /> Luxury Salon Experience
              </p>
              <p style={{ color: "#2062AF" }}>
                <FaCheck color="#F79219" /> Premium Branded Products
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
